export const DataHooks = {
  Root: 'ManageMenu.Root',
  Trigger: 'ManageMenu.Trigger',
  Header: 'ManageMenu.Header',
} as const;
